var map = {
	"./new_banner.jpg": "d980",
	"./new_banner_en.jpg": "5ba5",
	"./new_banner_es.jpg": "ff5f",
	"./new_banner_hk.jpg": "e0f4",
	"./new_banner_pt.jpg": "456b",
	"./new_banner_tr.jpg": "8b0e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fff9";